import React from "react";

// DRAFT: describes how the software behaves. Needs review by a lawyer before go-live.
const RefundPolicy = () => (
  <main className="mx-auto max-w-3xl px-5 py-16 text-slate-700">
    <p className="rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-sm font-medium text-amber-900">Draft for legal review. Not yet final.</p>
    <h1 className="mt-6 text-3xl font-extrabold text-slate-900">Refund and cancellation policy</h1>
    <h2 className="mt-8 text-lg font-bold text-slate-900">Appointments</h2>
    <p className="mt-2">You can cancel an appointment from the patient portal before the visit starts. If you cancel at least as long before the visit as your hospital's cancellation window (24 hours unless the hospital sets otherwise), the full amount is refunded automatically. Later cancellations are refunded at the hospital's discretion.</p>
    <p className="mt-2">If the hospital or doctor cancels, the full amount is refunded.</p>
    <h2 className="mt-8 text-lg font-bold text-slate-900">How refunds are paid</h2>
    <p className="mt-2">Refunds go to your original payment method and usually arrive in 5–7 working days, depending on your bank. Cash payments are refunded at the hospital. You can see refund status under Payments in the patient portal.</p>
    <h2 className="mt-8 text-lg font-bold text-slate-900">Payment problems</h2>
    <p className="mt-2">If money leaves your account but your slot is no longer available, the amount is refunded in full automatically.</p>
    <h2 className="mt-8 text-lg font-bold text-slate-900">Contact</h2>
    <p className="mt-2">Contact the hospital that provided your care, or write to techfrigate@gmail.com.</p>
  </main>
);

export default RefundPolicy;
